export default __webpack_public_path__ + "static/media/armorripper1.e9023c8e.png";